import { FormControl } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  error?: boolean;
  children: React.ReactNode;
  fullWidth?: boolean;
}

export const QcsFormControl: FC<Props> = ({ className, error, children, fullWidth }) => {
  return (
    <FormControl className={className} error={error} fullWidth={fullWidth}>
      {children}
    </FormControl>
  );
};
